// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';
import type {
  Client,
  ClientMeta,
  Options as Options2,
  RequestResult,
  ServerSentEventsResult,
  TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AcceptInvitationTokenData,
  AcceptInvitationTokenErrors,
  AcceptInvitationTokenResponses,
  CheckEmailData,
  CheckEmailErrors,
  CheckEmailResponses,
  CheckSlugData,
  CheckSlugErrors,
  CheckSlugResponses,
  ConfirmMagicLinkData,
  ConfirmMagicLinkErrors,
  CreateApiKeyData,
  CreateApiKeyErrors,
  CreateApiKeyResponses,
  CreateAttachmentsData,
  CreateAttachmentsErrors,
  CreateAttachmentsResponses,
  CreateDomainData,
  CreateDomainErrors,
  CreateDomainResponses,
  CreateOrganizationsData,
  CreateOrganizationsErrors,
  CreateOrganizationsResponses,
  CreatePasskeyData,
  CreatePasskeyErrors,
  CreatePasskeyResponses,
  CreatePushSubscriptionData,
  CreatePushSubscriptionErrors,
  CreatePushSubscriptionResponses,
  CreateRequestData,
  CreateRequestErrors,
  CreateRequestResponses,
  CreateServiceAccountData,
  CreateServiceAccountErrors,
  CreateServiceAccountResponses,
  CreateTotpData,
  CreateTotpErrors,
  CreateTotpResponses,
  DeleteAttachmentsData,
  DeleteAttachmentsErrors,
  DeleteAttachmentsResponses,
  DeleteDomainData,
  DeleteDomainErrors,
  DeleteDomainResponses,
  DeleteMeData,
  DeleteMeErrors,
  DeleteMembershipsData,
  DeleteMembershipsErrors,
  DeleteMembershipsResponses,
  DeleteMeResponses,
  DeleteMyMembershipData,
  DeleteMyMembershipErrors,
  DeleteMyMembershipResponses,
  DeleteOrganizationsData,
  DeleteOrganizationsErrors,
  DeleteOrganizationsResponses,
  DeletePasskeyData,
  DeletePasskeyErrors,
  DeletePasskeyResponses,
  DeletePushSubscriptionData,
  DeletePushSubscriptionErrors,
  DeletePushSubscriptionResponses,
  DeleteRequestsData,
  DeleteRequestsErrors,
  DeleteRequestsResponses,
  DeleteTotpData,
  DeleteTotpErrors,
  DeleteTotpResponses,
  DeleteUsersData,
  DeleteUsersErrors,
  DeleteUsersResponses,
  GeneratePasskeyChallengeData,
  GeneratePasskeyChallengeErrors,
  GeneratePasskeyChallengeResponses,
  GenerateTotpKeyData,
  GenerateTotpKeyErrors,
  GenerateTotpKeyResponses,
  GetApiKeysData,
  GetApiKeysErrors,
  GetApiKeysResponses,
  GetApiProtectedResourceMetadataData,
  GetApiProtectedResourceMetadataErrors,
  GetApiProtectedResourceMetadataResponses,
  GetAppStreamData,
  GetAppStreamErrors,
  GetAppStreamResponses,
  GetAttachmentData,
  GetAttachmentErrors,
  GetAttachmentResponses,
  GetAttachmentsData,
  GetAttachmentsErrors,
  GetAttachmentsResponses,
  GetAuthHealthData,
  GetAuthHealthErrors,
  GetAuthHealthResponses,
  GetConnectedAppsData,
  GetConnectedAppsErrors,
  GetConnectedAppsResponses,
  GetDomainData,
  GetDomainErrors,
  GetDomainResponses,
  GetDomainsData,
  GetDomainsErrors,
  GetDomainsResponses,
  GetMcpProtectedResourceMetadataData,
  GetMcpProtectedResourceMetadataErrors,
  GetMcpProtectedResourceMetadataResponses,
  GetMeData,
  GetMeErrors,
  GetMembersData,
  GetMembersErrors,
  GetMembersResponses,
  GetMeResponses,
  GetMyAuthData,
  GetMyAuthErrors,
  GetMyAuthResponses,
  GetMyInvitationsData,
  GetMyInvitationsErrors,
  GetMyInvitationsResponses,
  GetMyMembershipsData,
  GetMyMembershipsErrors,
  GetMyMembershipsResponses,
  GetNotificationPreferencesData,
  GetNotificationPreferencesErrors,
  GetNotificationPreferencesResponses,
  GetNotificationsData,
  GetNotificationsErrors,
  GetNotificationsResponses,
  GetOrganizationData,
  GetOrganizationErrors,
  GetOrganizationResponses,
  GetOrganizationsData,
  GetOrganizationsErrors,
  GetOrganizationsResponses,
  GetPendingMagicLinkData,
  GetPendingMagicLinkErrors,
  GetPendingMagicLinkResponses,
  GetPendingMembershipsData,
  GetPendingMembershipsErrors,
  GetPendingMembershipsResponses,
  GetPresignedUrlsData,
  GetPresignedUrlsErrors,
  GetPresignedUrlsResponses,
  GetPublicCountsData,
  GetPublicCountsErrors,
  GetPublicCountsResponses,
  GetPushVapidData,
  GetPushVapidErrors,
  GetPushVapidResponses,
  GetRequestsData,
  GetRequestsErrors,
  GetRequestsResponses,
  GetServiceAccountsData,
  GetServiceAccountsErrors,
  GetServiceAccountsResponses,
  GetStepUpData,
  GetStepUpErrors,
  GetStepUpPasskeyChallengeData,
  GetStepUpPasskeyChallengeErrors,
  GetStepUpPasskeyChallengeResponses,
  GetStepUpResponses,
  GetTenantsData,
  GetTenantsErrors,
  GetTenantsResponses,
  GetTokenDataData,
  GetTokenDataErrors,
  GetTokenDataResponses,
  GetUnseenCountsData,
  GetUnseenCountsErrors,
  GetUnseenCountsResponses,
  GetUploadTokenData,
  GetUploadTokenErrors,
  GetUploadTokenResponses,
  GetUserData,
  GetUserErrors,
  GetUserResponses,
  GetUsersData,
  GetUsersErrors,
  GetUsersResponses,
  GetYjsTokenData,
  GetYjsTokenErrors,
  GetYjsTokenResponses,
  GithubCallbackData,
  GithubCallbackErrors,
  GithubData,
  GithubErrors,
  GoogleCallbackData,
  GoogleCallbackErrors,
  GoogleData,
  GoogleErrors,
  HandleMcpData,
  HandleMcpErrors,
  HandleMcpResponses,
  HandleMembershipInvitationData,
  HandleMembershipInvitationErrors,
  HandleMembershipInvitationResponses,
  InvokeTokenData,
  InvokeTokenErrors,
  MarkNotificationsReadData,
  MarkNotificationsReadErrors,
  MarkNotificationsReadResponses,
  MarkSeenData,
  MarkSeenErrors,
  MarkSeenResponses,
  MembershipInviteData,
  MembershipInviteErrors,
  MembershipInviteResponses,
  MicrosoftCallbackData,
  MicrosoftCallbackErrors,
  MicrosoftData,
  MicrosoftErrors,
  PostAppCatchupData,
  PostAppCatchupErrors,
  PostAppCatchupResponses,
  ResendInvitationWithTokenData,
  ResendInvitationWithTokenErrors,
  ResendInvitationWithTokenResponses,
  ResendPendingInvitationData,
  ResendPendingInvitationErrors,
  ResendPendingInvitationResponses,
  RevokeApiKeyData,
  RevokeApiKeyErrors,
  RevokeApiKeyResponses,
  RevokeConnectedAppData,
  RevokeConnectedAppErrors,
  RevokeConnectedAppResponses,
  RevokeMySessionsData,
  RevokeMySessionsErrors,
  RevokeMySessionsResponses,
  SelfCreateTenantData,
  SelfCreateTenantErrors,
  SelfCreateTenantResponses,
  SendMagicLinkData,
  SendMagicLinkErrors,
  SendMagicLinkResponses,
  SendNewsletterData,
  SendNewsletterErrors,
  SendNewsletterResponses,
  SendStepUpLinkData,
  SendStepUpLinkErrors,
  SendStepUpLinkResponses,
  SignInWithPasskeyData,
  SignInWithPasskeyErrors,
  SignInWithPasskeyResponses,
  SignInWithTotpData,
  SignInWithTotpErrors,
  SignInWithTotpResponses,
  SignOutData,
  SignOutErrors,
  SignOutResponses,
  StartImpersonationData,
  StartImpersonationErrors,
  StartImpersonationResponses,
  StartOAuthConnectData,
  StartOAuthConnectErrors,
  StartOAuthConnectResponses,
  StepUpData,
  StepUpErrors,
  StepUpResponses,
  StopImpersonationData,
  StopImpersonationErrors,
  StopImpersonationResponses,
  SystemInviteData,
  SystemInviteErrors,
  SystemInviteResponses,
  ToggleMfaData,
  ToggleMfaErrors,
  ToggleMfaResponses,
  UnsubscribeNotificationsData,
  UnsubscribeNotificationsErrors,
  UpdateAttachmentData,
  UpdateAttachmentErrors,
  UpdateAttachmentResponses,
  UpdateMeData,
  UpdateMeErrors,
  UpdateMembershipData,
  UpdateMembershipErrors,
  UpdateMembershipResponses,
  UpdateMeResponses,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesErrors,
  UpdateNotificationPreferencesResponses,
  UpdateOrganizationData,
  UpdateOrganizationErrors,
  UpdateOrganizationResponses,
  UpdateServiceAccountData,
  UpdateServiceAccountErrors,
  UpdateServiceAccountResponses,
  UpdateTenantData,
  UpdateTenantErrors,
  UpdateTenantResponses,
  UpdateUserData,
  UpdateUserErrors,
  UpdateUserResponses,
  VerifyDomainData,
  VerifyDomainErrors,
  VerifyDomainResponses,
} from './types.gen';
import {
  zAcceptInvitationTokenResponse,
  zCheckEmailBody,
  zCheckEmailResponse,
  zCheckSlugBody,
  zCheckSlugPath,
  zCheckSlugResponse,
  zCreateApiKeyBody,
  zCreateApiKeyPath,
  zCreateApiKeyResponse,
  zCreateAttachmentsBody,
  zCreateAttachmentsPath,
  zCreateAttachmentsResponse,
  zCreateDomainBody,
  zCreateDomainPath,
  zCreateDomainResponse,
  zCreateOrganizationsBody,
  zCreateOrganizationsPath,
  zCreateOrganizationsResponse,
  zCreatePasskeyBody,
  zCreatePasskeyResponse,
  zCreatePushSubscriptionBody,
  zCreatePushSubscriptionResponse,
  zCreateRequestBody,
  zCreateRequestResponse,
  zCreateServiceAccountBody,
  zCreateServiceAccountPath,
  zCreateServiceAccountResponse,
  zCreateTotpBody,
  zDeleteAttachmentsBody,
  zDeleteAttachmentsPath,
  zDeleteAttachmentsResponse,
  zDeleteDomainPath,
  zDeleteDomainResponse,
  zDeleteMembershipsBody,
  zDeleteMembershipsPath,
  zDeleteMembershipsQuery,
  zDeleteMembershipsResponse,
  zDeleteMeResponse,
  zDeleteMyMembershipQuery,
  zDeleteMyMembershipResponse,
  zDeleteOrganizationsBody,
  zDeleteOrganizationsPath,
  zDeleteOrganizationsResponse,
  zDeletePasskeyPath,
  zDeletePasskeyResponse,
  zDeletePushSubscriptionQuery,
  zDeletePushSubscriptionResponse,
  zDeleteRequestsBody,
  zDeleteRequestsResponse,
  zDeleteTotpResponse,
  zDeleteUsersBody,
  zDeleteUsersResponse,
  zGeneratePasskeyChallengeBody,
  zGeneratePasskeyChallengeResponse,
  zGenerateTotpKeyResponse,
  zGetApiKeysPath,
  zGetApiKeysResponse,
  zGetApiProtectedResourceMetadataPath,
  zGetApiProtectedResourceMetadataResponse,
  zGetAttachmentPath,
  zGetAttachmentResponse,
  zGetAttachmentsPath,
  zGetAttachmentsQuery,
  zGetAttachmentsResponse,
  zGetAuthHealthResponse,
  zGetConnectedAppsResponse,
  zGetDomainPath,
  zGetDomainResponse,
  zGetDomainsPath,
  zGetDomainsResponse,
  zGetMcpProtectedResourceMetadataPath,
  zGetMcpProtectedResourceMetadataResponse,
  zGetMembersPath,
  zGetMembersQuery,
  zGetMembersResponse,
  zGetMeResponse,
  zGetMyAuthResponse,
  zGetMyInvitationsResponse,
  zGetMyMembershipsResponse,
  zGetNotificationPreferencesResponse,
  zGetNotificationsQuery,
  zGetNotificationsResponse,
  zGetOrganizationPath,
  zGetOrganizationQuery,
  zGetOrganizationResponse,
  zGetOrganizationsQuery,
  zGetOrganizationsResponse,
  zGetPendingMagicLinkResponse,
  zGetPendingMembershipsPath,
  zGetPendingMembershipsQuery,
  zGetPendingMembershipsResponse,
  zGetPresignedUrlsBody,
  zGetPresignedUrlsPath,
  zGetPresignedUrlsResponse,
  zGetPublicCountsResponse,
  zGetPushVapidResponse,
  zGetRequestsQuery,
  zGetRequestsResponse,
  zGetServiceAccountsPath,
  zGetServiceAccountsQuery,
  zGetServiceAccountsResponse,
  zGetStepUpPasskeyChallengeResponse,
  zGetStepUpResponse,
  zGetTenantsQuery,
  zGetTenantsResponse,
  zGetTokenDataPath,
  zGetTokenDataResponse,
  zGetUnseenCountsResponse,
  zGetUploadTokenQuery,
  zGetUploadTokenResponse,
  zGetUserPath,
  zGetUserQuery,
  zGetUserResponse,
  zGetUsersQuery,
  zGetUsersResponse,
  zGetYjsTokenPath,
  zGetYjsTokenQuery,
  zGetYjsTokenResponse,
  zGithubCallbackQuery,
  zGithubQuery,
  zGoogleCallbackQuery,
  zGoogleQuery,
  zHandleMcpBody,
  zHandleMcpPath,
  zHandleMembershipInvitationPath,
  zHandleMembershipInvitationResponse,
  zInvokeTokenPath,
  zMarkNotificationsReadBody,
  zMarkNotificationsReadResponse,
  zMarkSeenBody,
  zMarkSeenPath,
  zMarkSeenResponse,
  zMembershipInviteBody,
  zMembershipInvitePath,
  zMembershipInviteQuery,
  zMembershipInviteResponse,
  zMicrosoftCallbackQuery,
  zMicrosoftQuery,
  zPostAppCatchupBody,
  zPostAppCatchupResponse,
  zResendInvitationWithTokenBody,
  zResendInvitationWithTokenResponse,
  zResendPendingInvitationPath,
  zResendPendingInvitationResponse,
  zRevokeApiKeyPath,
  zRevokeApiKeyResponse,
  zRevokeConnectedAppPath,
  zRevokeConnectedAppResponse,
  zRevokeMySessionsBody,
  zRevokeMySessionsResponse,
  zSelfCreateTenantBody,
  zSelfCreateTenantResponse,
  zSendMagicLinkBody,
  zSendMagicLinkResponse,
  zSendNewsletterBody,
  zSendNewsletterQuery,
  zSendNewsletterResponse,
  zSendStepUpLinkBody,
  zSendStepUpLinkResponse,
  zSignInWithPasskeyBody,
  zSignInWithPasskeyResponse,
  zSignInWithTotpBody,
  zSignInWithTotpResponse,
  zSignOutResponse,
  zStartImpersonationBody,
  zStartImpersonationResponse,
  zStartOAuthConnectResponse,
  zStepUpBody,
  zStepUpResponse,
  zStopImpersonationResponse,
  zSystemInviteBody,
  zSystemInviteResponse,
  zToggleMfaBody,
  zToggleMfaResponse,
  zUnsubscribeNotificationsQuery,
  zUpdateAttachmentBody,
  zUpdateAttachmentPath,
  zUpdateAttachmentQuery,
  zUpdateAttachmentResponse,
  zUpdateMeBody,
  zUpdateMembershipBody,
  zUpdateMembershipPath,
  zUpdateMembershipResponse,
  zUpdateMeResponse,
  zUpdateNotificationPreferencesBody,
  zUpdateNotificationPreferencesResponse,
  zUpdateOrganizationBody,
  zUpdateOrganizationPath,
  zUpdateOrganizationResponse,
  zUpdateServiceAccountBody,
  zUpdateServiceAccountPath,
  zUpdateServiceAccountResponse,
  zUpdateTenantBody,
  zUpdateTenantPath,
  zUpdateTenantResponse,
  zUpdateUserBody,
  zUpdateUserPath,
  zUpdateUserResponse,
  zVerifyDomainPath,
  zVerifyDomainResponse,
} from './zod.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Auth health check
 *
 * Returns auth health status including whether the client IP is rate-limited for email enumeration protection.
 *
 * **GET /auth/health** ·· [getAuthHealth](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/health) ·· [getAuthHealth](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/health) ·· _auth_cella_
 *
 * @param {getAuthHealthData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getAuthHealth = <ThrowOnError extends boolean = true>(
  options?: Options<GetAuthHealthData, ThrowOnError>,
): RequestResult<GetAuthHealthResponses, GetAuthHealthErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetAuthHealthResponses, GetAuthHealthErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetAuthHealthResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/health',
    ...options,
  });

/**
 * Check email
 *
 * Tells whether this browser has signed in to the account with this email address before, by its device cookie. Any other browser gets `recognized: false`, whether or not the address has an account.
 *
 * **POST /auth/check-email** ·· [checkEmail](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/check-email) ·· [checkEmail](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/check-email) ·· _auth_cella_
 *
 * @param {checkEmailData} options
 * @param {string=} options.body.email - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const checkEmail = <ThrowOnError extends boolean = true>(
  options: Options<CheckEmailData, ThrowOnError>,
): RequestResult<CheckEmailResponses, CheckEmailErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CheckEmailResponses, CheckEmailErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCheckEmailBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCheckEmailResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/check-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Invoke token session
 *
 * Opens an emailed link of a link-carried token type: a magic link or a provider address verification signs in, a step-up link proves presence on this browser's session, an invitation hands the app a single-use token session in a cookie. Redirects to the app.
 *
 * **GET /auth/invoke-token/{type}/{token}** ·· [invokeToken](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/invoke-token/{type}/{token}) ·· [invokeToken](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/invoke-token/{type}/{token}) ·· _auth_cella_
 *
 * @param {invokeTokenData} options
 * @param {enum} options.path.type - `enum`
 * @param {string} options.path.token - `string`
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const invokeToken = <ThrowOnError extends boolean = true>(
  options: Options<InvokeTokenData, ThrowOnError>,
): RequestResult<unknown, InvokeTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, InvokeTokenErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zInvokeTokenPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/invoke-token/{type}/{token}',
    ...options,
  });

/**
 * Get token data
 *
 * Get basic token data from single-use token session, It returns basic data if the session is still valid.
 *
 * **GET /auth/token/{type}/{id}** ·· [getTokenData](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/token/{type}/{id}) ·· [getTokenData](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/token/{type}/{id}) ·· _auth_cella_
 *
 * @param {getTokenDataData} options
 * @param {enum} options.path.type - `enum`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getTokenData = <ThrowOnError extends boolean = true>(
  options: Options<GetTokenDataData, ThrowOnError>,
): RequestResult<GetTokenDataResponses, GetTokenDataErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetTokenDataResponses, GetTokenDataErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetTokenDataPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetTokenDataResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/token/{type}/{id}',
    ...options,
  });

/**
 * Accept invitation token as current user
 *
 * Accepts the membership invitation held in the single-use token session as the signed-in user, also when it was sent to a different email address. Only an invitation not yet bound to another user can be accepted this way.
 *
 * **POST /auth/invitation-token/accept** ·· [acceptInvitationToken](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/invitation-token/accept) ·· [acceptInvitationToken](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/invitation-token/accept) ·· _auth_cella_
 *
 * @param {acceptInvitationTokenData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const acceptInvitationToken = <ThrowOnError extends boolean = true>(
  options?: Options<AcceptInvitationTokenData, ThrowOnError>,
): RequestResult<AcceptInvitationTokenResponses, AcceptInvitationTokenErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<AcceptInvitationTokenResponses, AcceptInvitationTokenErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zAcceptInvitationTokenResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/invitation-token/accept',
    ...options,
  });

/**
 * Start impersonating
 *
 * Allows a system admin to impersonate a specific user by ID, returning a temporary impersonation session.
 *
 * **POST /auth/impersonation/start** ·· [startImpersonation](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/impersonation/start) ·· [startImpersonation](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/impersonation/start) ·· _auth_cella_
 *
 * @param {startImpersonationData} options
 * @param {string=} options.body.targetUserId - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const startImpersonation = <ThrowOnError extends boolean = true>(
  options: Options<StartImpersonationData, ThrowOnError>,
): RequestResult<StartImpersonationResponses, StartImpersonationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<StartImpersonationResponses, StartImpersonationErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStartImpersonationBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zStartImpersonationResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/impersonation/start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Stop impersonating
 *
 * Ends impersonation by clearing the current impersonation session and restoring the admin context.
 *
 * **POST /auth/impersonation/stop** ·· [stopImpersonation](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/impersonation/stop) ·· [stopImpersonation](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/impersonation/stop) ·· _auth_cella_
 *
 * @param {stopImpersonationData} options
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const stopImpersonation = <ThrowOnError extends boolean = true>(
  options?: Options<StopImpersonationData, ThrowOnError>,
): RequestResult<StopImpersonationResponses, StopImpersonationErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<StopImpersonationResponses, StopImpersonationErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zStopImpersonationResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/impersonation/stop',
    ...options,
  });

/**
 * Resend invitation
 *
 * Re-sends a pending invitation, named by the id of one of its tokens, to the address it went to. The fresh link replaces the older ones. Answers 204 whether or not an email went out.
 *
 * **POST /auth/resend-invitation** ·· [resendInvitationWithToken](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/resend-invitation) ·· [resendInvitationWithToken](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/resend-invitation) ·· _auth_cella_
 *
 * @param {resendInvitationWithTokenData} options
 * @param {string=} options.body.tokenId - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const resendInvitationWithToken = <ThrowOnError extends boolean = true>(
  options: Options<ResendInvitationWithTokenData, ThrowOnError>,
): RequestResult<ResendInvitationWithTokenResponses, ResendInvitationWithTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<
    ResendInvitationWithTokenResponses,
    ResendInvitationWithTokenErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zResendInvitationWithTokenBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zResendInvitationWithTokenResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/resend-invitation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Sign out
 *
 * Signs out the current user: the session is revoked (its row stays for the sessions list) and the cookie is cleared.
 *
 * **POST /auth/sign-out** ·· [signOut](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/sign-out) ·· [signOut](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/sign-out) ·· _auth_cella_
 *
 * @param {signOutData} options
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const signOut = <ThrowOnError extends boolean = true>(
  options?: Options<SignOutData, ThrowOnError>,
): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSignOutResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/sign-out',
    ...options,
  });

/**
 * Send magic link
 *
 * Sends a magic link sign-in email to the specified address. Always returns 204 to prevent email enumeration.
 *
 * **POST /auth/magic/send** ·· [sendMagicLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/magic/send) ·· [sendMagicLink](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/magic/send) ·· _auth_cella_
 *
 * @param {sendMagicLinkData} options
 * @param {string=} options.body.email - `string` (optional)
 * @param {string=} options.body.redirect - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const sendMagicLink = <ThrowOnError extends boolean = true>(
  options: Options<SendMagicLinkData, ThrowOnError>,
): RequestResult<SendMagicLinkResponses, SendMagicLinkErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SendMagicLinkResponses, SendMagicLinkErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSendMagicLinkBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSendMagicLinkResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/magic/send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get pending magic link
 *
 * For a magic link opened in a browser that did not request it: the address it signs in, so the holder can recognize the account before confirming.
 *
 * **GET /auth/magic/pending** ·· [getPendingMagicLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/magic/pending) ·· [getPendingMagicLink](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/magic/pending) ·· _auth_cella_
 *
 * @param {getPendingMagicLinkData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getPendingMagicLink = <ThrowOnError extends boolean = true>(
  options?: Options<GetPendingMagicLinkData, ThrowOnError>,
): RequestResult<GetPendingMagicLinkResponses, GetPendingMagicLinkErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetPendingMagicLinkResponses, GetPendingMagicLinkErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetPendingMagicLinkResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/magic/pending',
    ...options,
  });

/**
 * Confirm magic link
 *
 * Signs in with the magic link this browser holds, confirmed from the app page. A form post from the app origin; redirects like opening the link.
 *
 * **POST /auth/magic/confirm** ·· [confirmMagicLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/magic/confirm) ·· [confirmMagicLink](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/magic/confirm) ·· _auth_cella_
 *
 * @param {confirmMagicLinkData} options
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const confirmMagicLink = <ThrowOnError extends boolean = true>(
  options?: Options<ConfirmMagicLinkData, ThrowOnError>,
): RequestResult<unknown, ConfirmMagicLinkErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<unknown, ConfirmMagicLinkErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/magic/confirm',
    ...options,
  });

/**
 * Generate TOTP key
 *
 * Generates a new TOTP key for current user and returns a provisioning URI and Base32 manual key.
 *
 * **POST /auth/totp/generate-key** ·· [generateTotpKey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/totp/generate-key) ·· [generateTotpKey](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/totp/generate-key) ·· _auth_cella_
 *
 * @param {generateTotpKeyData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const generateTotpKey = <ThrowOnError extends boolean = true>(
  options?: Options<GenerateTotpKeyData, ThrowOnError>,
): RequestResult<GenerateTotpKeyResponses, GenerateTotpKeyErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<GenerateTotpKeyResponses, GenerateTotpKeyErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGenerateTotpKeyResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/totp/generate-key',
    ...options,
  });

/**
 * Delete TOTP
 *
 * Delete TOTP credential for current user.
 *
 * **DELETE /auth/totp** ·· [deleteTotp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/DELETE/auth/totp) ·· [deleteTotp](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/auth/totp) ·· _auth_cella_
 *
 * @param {deleteTotpData} options
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const deleteTotp = <ThrowOnError extends boolean = true>(
  options?: Options<DeleteTotpData, ThrowOnError>,
): RequestResult<DeleteTotpResponses, DeleteTotpErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).delete<DeleteTotpResponses, DeleteTotpErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteTotpResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/totp',
    ...options,
  });

/**
 * Set TOTP
 *
 * Confirms TOTP setup by verifying a code from the authenticator app for the first time. On success, TOTP is registered for current user.
 *
 * **POST /auth/totp** ·· [createTotp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/totp) ·· [createTotp](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/totp) ·· _auth_cella_
 *
 * @param {createTotpData} options
 * @param {string=} options.body.code - `string` (optional)
 * @returns Possible status codes: 201, 400, 401, 403, 404, 409, 429
 */
export const createTotp = <ThrowOnError extends boolean = true>(
  options: Options<CreateTotpData, ThrowOnError>,
): RequestResult<CreateTotpResponses, CreateTotpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateTotpResponses, CreateTotpErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateTotpBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/totp',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify TOTP
 *
 * Validates the TOTP code and completes TOTP based authentication.
 *
 * **POST /auth/totp-verification** ·· [signInWithTotp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/totp-verification) ·· [signInWithTotp](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/totp-verification) ·· _auth_cella_
 *
 * @param {signInWithTotpData} options
 * @param {string=} options.body.code - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const signInWithTotp = <ThrowOnError extends boolean = true>(
  options: Options<SignInWithTotpData, ThrowOnError>,
): RequestResult<SignInWithTotpResponses, SignInWithTotpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SignInWithTotpResponses, SignInWithTotpErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSignInWithTotpBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSignInWithTotpResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/totp-verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create passkey
 *
 * Register a passkey for passwordless authentication by verifying a signed challenge and linking it to the current user. Multiple passkeys can be created for different devices/browsers.
 *
 * **POST /auth/passkey** ·· [createPasskey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/passkey) ·· [createPasskey](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/passkey) ·· _auth_cella_
 *
 * @param {createPasskeyData} options
 * @param {object} options.body.attestation - `object`
 * @param {string=} options.body.nameOnDevice - `string` (optional)
 * @returns Possible status codes: 201, 400, 401, 403, 404, 409, 429
 */
export const createPasskey = <ThrowOnError extends boolean = true>(
  options: Options<CreatePasskeyData, ThrowOnError>,
): RequestResult<CreatePasskeyResponses, CreatePasskeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreatePasskeyResponses, CreatePasskeyErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreatePasskeyBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreatePasskeyResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/passkey',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete passkey
 *
 * Delete a passkey by id from the current user.
 *
 * **DELETE /auth/passkey/{id}** ·· [deletePasskey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/DELETE/auth/passkey/{id}) ·· [deletePasskey](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/auth/passkey/{id}) ·· _auth_cella_
 *
 * @param {deletePasskeyData} options
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const deletePasskey = <ThrowOnError extends boolean = true>(
  options: Options<DeletePasskeyData, ThrowOnError>,
): RequestResult<DeletePasskeyResponses, DeletePasskeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeletePasskeyResponses, DeletePasskeyErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeletePasskeyPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeletePasskeyResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/passkey/{id}',
    ...options,
  });

/**
 * Generate passkey challenge
 *
 * Initiates the passkey registration or authentication flow by generating a device bound challenge.
 *
 * **POST /auth/passkey/generate-challenge** ·· [generatePasskeyChallenge](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/passkey/generate-challenge) ·· [generatePasskeyChallenge](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/passkey/generate-challenge) ·· _auth_cella_
 *
 * @param {generatePasskeyChallengeData} options
 * @param {enum=} options.body.type - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const generatePasskeyChallenge = <ThrowOnError extends boolean = true>(
  options: Options<GeneratePasskeyChallengeData, ThrowOnError>,
): RequestResult<GeneratePasskeyChallengeResponses, GeneratePasskeyChallengeErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<
    GeneratePasskeyChallengeResponses,
    GeneratePasskeyChallengeErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGeneratePasskeyChallengeBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGeneratePasskeyChallengeResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/passkey/generate-challenge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify passkey
 *
 * Validates the signed challenge and completes passkey based authentication.
 *
 * **POST /auth/passkey-verification** ·· [signInWithPasskey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/passkey-verification) ·· [signInWithPasskey](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/passkey-verification) ·· _auth_cella_
 *
 * @param {signInWithPasskeyData} options
 * @param {object} options.body.assertion - `object`
 * @param {enum=} options.body.type - `enum` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const signInWithPasskey = <ThrowOnError extends boolean = true>(
  options: Options<SignInWithPasskeyData, ThrowOnError>,
): RequestResult<SignInWithPasskeyResponses, SignInWithPasskeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SignInWithPasskeyResponses, SignInWithPasskeyErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSignInWithPasskeyBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSignInWithPasskeyResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/passkey-verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start connecting a provider
 *
 * Pins this browser's next provider sign-in with `type=connect` to the current user, for ten minutes and once: the provider's callback connects the provider account to the user that started it. Call it right before sending the browser to the provider.
 *
 * **POST /auth/oauth-connect** ·· [startOAuthConnect](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/oauth-connect) ·· [startOAuthConnect](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/oauth-connect) ·· _auth_cella_
 *
 * @param {startOAuthConnectData} options
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const startOAuthConnect = <ThrowOnError extends boolean = true>(
  options?: Options<StartOAuthConnectData, ThrowOnError>,
): RequestResult<StartOAuthConnectResponses, StartOAuthConnectErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<StartOAuthConnectResponses, StartOAuthConnectErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zStartOAuthConnectResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/oauth-connect',
    ...options,
  });

/**
 * Authenticate with GitHub
 *
 * Starts OAuth authentication with GitHub. Can be used for account connection, email verification, invitation process, defaults to authentication.
 *
 * **GET /auth/github** ·· [github](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/github) ·· [github](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/github) ·· _auth_cella_
 *
 * @param {githubData} options
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectafter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const github = <ThrowOnError extends boolean = true>(
  options?: Options<GithubData, ThrowOnError>,
): RequestResult<unknown, GithubErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<unknown, GithubErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGithubQuery.optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/github',
    ...options,
  });

/**
 * Authenticate with Google
 *
 * Starts OAuth authentication with Google. Can be used for account connection, email verification, invitation process, defaults to authentication.
 *
 * **GET /auth/google** ·· [google](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/google) ·· [google](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/google) ·· _auth_cella_
 *
 * @param {googleData} options
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectafter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const google = <ThrowOnError extends boolean = true>(
  options?: Options<GoogleData, ThrowOnError>,
): RequestResult<unknown, GoogleErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<unknown, GoogleErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGoogleQuery.optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/google',
    ...options,
  });

/**
 * Authenticate with Microsoft
 *
 * Starts OAuth authentication with Microsoft. Can be used for account connection, email verification, invitation process, defaults to authentication.
 *
 * **GET /auth/microsoft** ·· [microsoft](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/microsoft) ·· [microsoft](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/microsoft) ·· _auth_cella_
 *
 * @param {microsoftData} options
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectafter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const microsoft = <ThrowOnError extends boolean = true>(
  options?: Options<MicrosoftData, ThrowOnError>,
): RequestResult<unknown, MicrosoftErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<unknown, MicrosoftErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zMicrosoftQuery.optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/microsoft',
    ...options,
  });

/**
 * Callback for GitHub
 *
 * Handles GitHub OAuth callback, retrieves user identity, and establishes a session or links account.
 *
 * **GET /auth/github/callback** ·· [githubCallback](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/github/callback) ·· [githubCallback](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/github/callback) ·· _auth_cella_
 *
 * @param {githubCallbackData} options
 * @param {string} options.query.code - `string`
 * @param {string} options.query.state - `string`
 * @param {string=} options.query.error - `string` (optional)
 * @param {string=} options.query.error_description - `string` (optional)
 * @param {string=} options.query.error_uri - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const githubCallback = <ThrowOnError extends boolean = true>(
  options: Options<GithubCallbackData, ThrowOnError>,
): RequestResult<unknown, GithubCallbackErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, GithubCallbackErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGithubCallbackQuery,
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/github/callback',
    ...options,
  });

/**
 * Callback for Google
 *
 * Handles Google OAuth callback, retrieves user identity, and establishes a session or links account.
 *
 * **GET /auth/google/callback** ·· [googleCallback](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/google/callback) ·· [googleCallback](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/google/callback) ·· _auth_cella_
 *
 * @param {googleCallbackData} options
 * @param {string} options.query.code - `string`
 * @param {string} options.query.state - `string`
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const googleCallback = <ThrowOnError extends boolean = true>(
  options: Options<GoogleCallbackData, ThrowOnError>,
): RequestResult<unknown, GoogleCallbackErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, GoogleCallbackErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGoogleCallbackQuery,
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/google/callback',
    ...options,
  });

/**
 * Callback for Microsoft
 *
 * Handles Microsoft OAuth callback, retrieves user identity, and establishes a session or links account.
 *
 * **GET /auth/microsoft/callback** ·· [microsoftCallback](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/microsoft/callback) ·· [microsoftCallback](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/microsoft/callback) ·· _auth_cella_
 *
 * @param {microsoftCallbackData} options
 * @param {string} options.query.code - `string`
 * @param {string} options.query.state - `string`
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const microsoftCallback = <ThrowOnError extends boolean = true>(
  options: Options<MicrosoftCallbackData, ThrowOnError>,
): RequestResult<unknown, MicrosoftCallbackErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, MicrosoftCallbackErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zMicrosoftCallbackQuery,
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/auth/microsoft/callback',
    ...options,
  });

/**
 * Get step-up state
 *
 * Whether this session stands stepped up for account-security actions, and what the user can offer to step up: a passkey or TOTP they hold, else an emailed confirmation link or a new sign-in.
 *
 * **GET /auth/step-up** ·· [getStepUp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/step-up) ·· [getStepUp](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/auth/step-up) ·· _auth_cella_
 *
 * @param {getStepUpData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getStepUp = <ThrowOnError extends boolean = true>(
  options?: Options<GetStepUpData, ThrowOnError>,
): RequestResult<GetStepUpResponses, GetStepUpErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetStepUpResponses, GetStepUpErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetStepUpResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/step-up',
    ...options,
  });

/**
 * Step up with a second factor
 *
 * Proves the user is present on this session with a passkey assertion (to a step-up passkey challenge) or a TOTP code of a factor they hold. Account-security actions then pass for ten minutes.
 *
 * **POST /auth/step-up** ·· [stepUp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/step-up) ·· [stepUp](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/step-up) ·· _auth_cella_
 *
 * @param {stepUpData} options
 * @param {object} options.body.passkeyData - `object`
 * @param {string=} options.body.totpCode - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const stepUp = <ThrowOnError extends boolean = true>(
  options: Options<StepUpData, ThrowOnError>,
): RequestResult<StepUpResponses, StepUpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<StepUpResponses, StepUpErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStepUpBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zStepUpResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/step-up',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a step-up passkey challenge
 *
 * Issues a passkey challenge for a step-up of this session, bound to the current user, with the user's passkeys to offer. Only a step-up answers it.
 *
 * **POST /auth/step-up/passkey-challenge** ·· [getStepUpPasskeyChallenge](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/step-up/passkey-challenge) ·· [getStepUpPasskeyChallenge](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/step-up/passkey-challenge) ·· _auth_cella_
 *
 * @param {getStepUpPasskeyChallengeData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getStepUpPasskeyChallenge = <ThrowOnError extends boolean = true>(
  options?: Options<GetStepUpPasskeyChallengeData, ThrowOnError>,
): RequestResult<GetStepUpPasskeyChallengeResponses, GetStepUpPasskeyChallengeErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<
    GetStepUpPasskeyChallengeResponses,
    GetStepUpPasskeyChallengeErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetStepUpPasskeyChallengeResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/step-up/passkey-challenge',
    ...options,
  });

/**
 * Email a step-up link
 *
 * For a user without a passkey or TOTP: emails a confirmation link that steps up this session when opened in this browser within ten minutes. The link signs nobody in.
 *
 * **POST /auth/step-up/link** ·· [sendStepUpLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/step-up/link) ·· [sendStepUpLink](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/auth/step-up/link) ·· _auth_cella_
 *
 * @param {sendStepUpLinkData} options
 * @param {string=} options.body.redirect - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const sendStepUpLink = <ThrowOnError extends boolean = true>(
  options?: Options<SendStepUpLinkData, ThrowOnError>,
): RequestResult<SendStepUpLinkResponses, SendStepUpLinkErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<SendStepUpLinkResponses, SendStepUpLinkErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSendStepUpLinkBody.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSendStepUpLinkResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/auth/step-up/link',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * List domains for a tenant
 *
 * Returns all domains belonging to a tenant, including verification tokens. System admin access required.
 *
 * **GET /tenants/{tenantId}/domains** ·· [getDomains](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/GET/tenants/{tenantId}/domains) ·· [getDomains](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/tenants/{tenantId}/domains) ·· _tenants_cella_
 *
 * @param {getDomainsData} options
 * @param {string} options.path.tenantid - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getDomains = <ThrowOnError extends boolean = true>(
  options: Options<GetDomainsData, ThrowOnError>,
): RequestResult<GetDomainsResponses, GetDomainsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetDomainsResponses, GetDomainsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetDomainsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetDomainsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants/{tenantId}/domains',
    ...options,
  });

/**
 * Add a domain to a tenant
 *
 * Adds a new domain to a tenant. The domain starts unverified. System admin access required.
 *
 * **POST /tenants/{tenantId}/domains** ·· [createDomain](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/POST/tenants/{tenantId}/domains) ·· [createDomain](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/tenants/{tenantId}/domains) ·· _tenants_cella_
 *
 * @param {createDomainData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string=} options.body.domain - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const createDomain = <ThrowOnError extends boolean = true>(
  options: Options<CreateDomainData, ThrowOnError>,
): RequestResult<CreateDomainResponses, CreateDomainErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateDomainResponses, CreateDomainErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateDomainBody,
          path: zCreateDomainPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreateDomainResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants/{tenantId}/domains',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a domain
 *
 * Removes a domain from a tenant. System admin access required.
 *
 * **DELETE /tenants/{tenantId}/domains/{id}** ·· [deleteDomain](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/DELETE/tenants/{tenantId}/domains/{id}) ·· [deleteDomain](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/tenants/{tenantId}/domains/{id}) ·· _tenants_cella_
 *
 * @param {deleteDomainData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const deleteDomain = <ThrowOnError extends boolean = true>(
  options: Options<DeleteDomainData, ThrowOnError>,
): RequestResult<DeleteDomainResponses, DeleteDomainErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteDomainResponses, DeleteDomainErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteDomainPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteDomainResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants/{tenantId}/domains/{id}',
    ...options,
  });

/**
 * Get domain with verification token
 *
 * Returns a single domain including its verification token for DNS TXT setup. System admin access required.
 *
 * **GET /tenants/{tenantId}/domains/{id}** ·· [getDomain](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/GET/tenants/{tenantId}/domains/{id}) ·· [getDomain](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/tenants/{tenantId}/domains/{id}) ·· _tenants_cella_
 *
 * @param {getDomainData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getDomain = <ThrowOnError extends boolean = true>(
  options: Options<GetDomainData, ThrowOnError>,
): RequestResult<GetDomainResponses, GetDomainErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetDomainResponses, GetDomainErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetDomainPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetDomainResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants/{tenantId}/domains/{id}',
    ...options,
  });

/**
 * Verify domain ownership via DNS
 *
 * Looks up DNS TXT records for the domain to verify ownership. Checks for a _cella-development-verification.<domain> TXT record matching the verification token.
 *
 * **POST /tenants/{tenantId}/domains/{id}/verify** ·· [verifyDomain](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/POST/tenants/{tenantId}/domains/{id}/verify) ·· [verifyDomain](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/tenants/{tenantId}/domains/{id}/verify) ·· _tenants_cella_
 *
 * @param {verifyDomainData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const verifyDomain = <ThrowOnError extends boolean = true>(
  options: Options<VerifyDomainData, ThrowOnError>,
): RequestResult<VerifyDomainResponses, VerifyDomainErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<VerifyDomainResponses, VerifyDomainErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zVerifyDomainPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zVerifyDomainResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants/{tenantId}/domains/{id}/verify',
    ...options,
  });

/**
 * Check slug availability
 *
 * Checks whether a given slug is available within a tenant for the specified entity type.
 * Primarily used to prevent slug collisions before creating or updating an entity.
 *
 * **POST /entities/{tenantId}/check-slug** ·· [checkSlug](https://www.cellajs.com/docs/operations?operationTag=entities#tag/entities/POST/entities/{tenantId}/check-slug) ·· [checkSlug](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/entities/{tenantId}/check-slug) ·· _entities_cella_
 *
 * @param {checkSlugData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string=} options.body.slug - `string` (optional)
 * @param {enum=} options.body.entityType - `enum` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const checkSlug = <ThrowOnError extends boolean = true>(
  options: Options<CheckSlugData, ThrowOnError>,
): RequestResult<CheckSlugResponses, CheckSlugErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CheckSlugResponses, CheckSlugErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCheckSlugBody,
          path: zCheckSlugPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCheckSlugResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/entities/{tenantId}/check-slug',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * App event SSE stream
 *
 * SSE stream for membership and entity notifications affecting the current user. Sends lightweight notifications.
 *
 * **GET /entities/app/stream** ·· [getAppStream](https://www.cellajs.com/docs/operations?operationTag=entities#tag/entities/GET/entities/app/stream) ·· [getAppStream](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/entities/app/stream) ·· _entities_cella_
 *
 * @param {getAppStreamData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getAppStream = <ThrowOnError extends boolean = true>(
  options?: Options<GetAppStreamData, ThrowOnError, unknown>,
): Promise<ServerSentEventsResult<GetAppStreamResponses>> =>
  (options?.client ?? client).sse.get<GetAppStreamResponses, GetAppStreamErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/entities/app/stream',
    ...options,
  });

/**
 * App event catchup
 *
 * Fetch missed entity and membership changes since last sync. Send cursor and declared views (prefix sets + org-sequence cursors) in the body.
 *
 * **POST /entities/app/stream** ·· [postAppCatchup](https://www.cellajs.com/docs/operations?operationTag=entities#tag/entities/POST/entities/app/stream) ·· [postAppCatchup](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/entities/app/stream) ·· _entities_cella_
 *
 * @param {postAppCatchupData} options
 * @param {string=} options.body.cursor - `string` (optional)
 * @param {any[]=} options.body.views - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const postAppCatchup = <ThrowOnError extends boolean = true>(
  options: Options<PostAppCatchupData, ThrowOnError>,
): RequestResult<PostAppCatchupResponses, PostAppCatchupErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<PostAppCatchupResponses, PostAppCatchupErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zPostAppCatchupBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zPostAppCatchupResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/entities/app/stream',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete self
 *
 * Deletes the current user. This also removes the user's memberships (cascade) and sets references to the user to null where applicable.
 *
 * **DELETE /me** ·· [deleteMe](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me) ·· [deleteMe](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/me) ·· _me_cella_
 *
 * @param {deleteMeData} options
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const deleteMe = <ThrowOnError extends boolean = true>(
  options?: Options<DeleteMeData, ThrowOnError>,
): RequestResult<DeleteMeResponses, DeleteMeErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).delete<DeleteMeResponses, DeleteMeErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteMeResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me',
    ...options,
  });

/**
 * Get self
 *
 * Returns the current user.
 *
 * **GET /me** ·· [getMe](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me) ·· [getMe](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/me) ·· _me_cella_
 *
 * @param {getMeData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getMe = <ThrowOnError extends boolean = true>(
  options?: Options<GetMeData, ThrowOnError>,
): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetMeResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me',
    ...options,
  });

/**
 * Update self
 *
 * Updates the current user.
 *
 * **PUT /me** ·· [updateMe](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/PUT/me) ·· [updateMe](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/me) ·· _me_cella_
 *
 * @param {updateMeData} options
 * @param {string | null=} options.body.bannerUrl - `string | null` (optional)
 * @param {string | null=} options.body.description - `string | null` (optional)
 * @param {string | null=} options.body.firstName - `string | null` (optional)
 * @param {string | null=} options.body.lastName - `string | null` (optional)
 * @param {enum=} options.body.language - `enum` (optional)
 * @param {boolean=} options.body.newsletter - `boolean` (optional)
 * @param {string | null=} options.body.thumbnailUrl - `string | null` (optional)
 * @param {string=} options.body.slug - `string` (optional)
 * @param {object=} options.body.userFlags - `object` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateMe = <ThrowOnError extends boolean = true>(
  options: Options<UpdateMeData, ThrowOnError>,
): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateMeResponses, UpdateMeErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateMeBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateMeResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Toggle MFA
 *
 * Enable or disable multifactor authentication for the current user. Needs a session stepped up with a passkey or TOTP.
 *
 * **PUT /me/mfa** ·· [toggleMfa](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/PUT/me/mfa) ·· [toggleMfa](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/me/mfa) ·· _me_cella_
 *
 * @param {toggleMfaData} options
 * @param {boolean=} options.body.mfaRequired - `boolean` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const toggleMfa = <ThrowOnError extends boolean = true>(
  options: Options<ToggleMfaData, ThrowOnError>,
): RequestResult<ToggleMfaResponses, ToggleMfaErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<ToggleMfaResponses, ToggleMfaErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zToggleMfaBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zToggleMfaResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/mfa',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get auth data
 *
 * Returns authentication related data of current user, including sessions, passkeys, TOTP and the enabled sign-in providers.
 *
 * **GET /me/auth** ·· [getMyAuth](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/auth) ·· [getMyAuth](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/me/auth) ·· _me_cella_
 *
 * @param {getMyAuthData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getMyAuth = <ThrowOnError extends boolean = true>(
  options?: Options<GetMyAuthData, ThrowOnError>,
): RequestResult<GetMyAuthResponses, GetMyAuthErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMyAuthResponses, GetMyAuthErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetMyAuthResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/auth',
    ...options,
  });

/**
 * Get list of invitations
 *
 * Returns a list of pending memberships with entity data.
 *
 * **GET /me/invitations** ·· [getMyInvitations](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/invitations) ·· [getMyInvitations](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/me/invitations) ·· _me_cella_
 *
 * @param {getMyInvitationsData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getMyInvitations = <ThrowOnError extends boolean = true>(
  options?: Options<GetMyInvitationsData, ThrowOnError>,
): RequestResult<GetMyInvitationsResponses, GetMyInvitationsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMyInvitationsResponses, GetMyInvitationsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetMyInvitationsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/invitations',
    ...options,
  });

/**
 * Revoke sessions
 *
 * Revokes sessions of the current user by id. The rows stay for the audit trail and the sessions list shows them as revoked for 30 days. Revoking the current session signs out.
 *
 * **DELETE /me/sessions** ·· [revokeMySessions](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me/sessions) ·· [revokeMySessions](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/me/sessions) ·· _me_cella_
 *
 * @param {revokeMySessionsData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const revokeMySessions = <ThrowOnError extends boolean = true>(
  options: Options<RevokeMySessionsData, ThrowOnError>,
): RequestResult<RevokeMySessionsResponses, RevokeMySessionsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<RevokeMySessionsResponses, RevokeMySessionsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRevokeMySessionsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zRevokeMySessionsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Leave entity
 *
 * Removes the current user from an entity they are a member of.
 *
 * **DELETE /me/leave** ·· [deleteMyMembership](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me/leave) ·· [deleteMyMembership](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/me/leave) ·· _me_cella_
 *
 * @param {deleteMyMembershipData} options
 * @param {string} options.query.entityid - `string`
 * @param {enum} options.query.entitytype - `enum`
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const deleteMyMembership = <ThrowOnError extends boolean = true>(
  options: Options<DeleteMyMembershipData, ThrowOnError>,
): RequestResult<DeleteMyMembershipResponses, DeleteMyMembershipErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteMyMembershipResponses, DeleteMyMembershipErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zDeleteMyMembershipQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteMyMembershipResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/leave',
    ...options,
  });

/**
 * Get upload token
 *
 * Generates and returns an upload token for uploading files or images, scoped to the current user and organization. The upload template decides the bucket: avatars, covers and newsletter images are public, attachments private. Only a system admin gets a newsletter image token.
 *
 * **GET /me/upload-token** ·· [getUploadToken](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/upload-token) ·· [getUploadToken](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/me/upload-token) ·· _me_cella_
 *
 * @param {getUploadTokenData} options
 * @param {string=} options.query.organizationid - `string` (optional)
 * @param {enum} options.query.templateid - `enum`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getUploadToken = <ThrowOnError extends boolean = true>(
  options: Options<GetUploadTokenData, ThrowOnError>,
): RequestResult<GetUploadTokenResponses, GetUploadTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetUploadTokenResponses, GetUploadTokenErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetUploadTokenQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetUploadTokenResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/upload-token',
    ...options,
  });

/**
 * Get my memberships
 *
 * Returns all memberships for the current user across all channel entities.
 *
 * **GET /me/memberships** ·· [getMyMemberships](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/memberships) ·· [getMyMemberships](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/me/memberships) ·· _me_cella_
 *
 * @param {getMyMembershipsData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getMyMemberships = <ThrowOnError extends boolean = true>(
  options?: Options<GetMyMembershipsData, ThrowOnError>,
): RequestResult<GetMyMembershipsResponses, GetMyMembershipsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMyMembershipsResponses, GetMyMembershipsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetMyMembershipsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/memberships',
    ...options,
  });

/**
 * Get connected apps
 *
 * Lists the OAuth clients the user consented to (MCP clients, registered apps) with their scopes.
 *
 * **GET /me/connected-apps** ·· [getConnectedApps](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/connected-apps) ·· [getConnectedApps](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/me/connected-apps) ·· _me_cella_
 *
 * @param {getConnectedAppsData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getConnectedApps = <ThrowOnError extends boolean = true>(
  options?: Options<GetConnectedAppsData, ThrowOnError>,
): RequestResult<GetConnectedAppsResponses, GetConnectedAppsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetConnectedAppsResponses, GetConnectedAppsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetConnectedAppsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/connected-apps',
    ...options,
  });

/**
 * Revoke connected app
 *
 * Revokes a consent: the grant and every token issued under it are deleted.
 *
 * **DELETE /me/connected-apps/{id}** ·· [revokeConnectedApp](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me/connected-apps/{id}) ·· [revokeConnectedApp](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/me/connected-apps/{id}) ·· _me_cella_
 *
 * @param {revokeConnectedAppData} options
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const revokeConnectedApp = <ThrowOnError extends boolean = true>(
  options: Options<RevokeConnectedAppData, ThrowOnError>,
): RequestResult<RevokeConnectedAppResponses, RevokeConnectedAppErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<RevokeConnectedAppResponses, RevokeConnectedAppErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zRevokeConnectedAppPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zRevokeConnectedAppResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/me/connected-apps/{id}',
    ...options,
  });

/**
 * Get public counts
 *
 * Returns basic count metrics for entity types such as users and organizations.
 * This endpoint is public and uses a 1 minute in memory cache for performance.
 *
 * **GET /metrics/public** ·· [getPublicCounts](https://www.cellajs.com/docs/operations?operationTag=metrics#tag/metrics/GET/metrics/public) ·· [getPublicCounts](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/metrics/public) ·· _metrics_cella_
 *
 * @param {getPublicCountsData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getPublicCounts = <ThrowOnError extends boolean = true>(
  options?: Options<GetPublicCountsData, ThrowOnError>,
): RequestResult<GetPublicCountsResponses, GetPublicCountsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetPublicCountsResponses, GetPublicCountsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetPublicCountsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/metrics/public',
    ...options,
  });

/**
 * List notifications
 *
 * Returns the current user notification inbox, newest first, with the unread count. Ambient posts are not included: those are covered by unseen counts. Rows older than the retention window are removed with their partition.
 *
 * **GET /notifications** ·· [getNotifications](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/GET/notifications) ·· _notifications_
 *
 * @param {getNotificationsData} options
 * @param {enum=} options.query.unread - `enum` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {string=} options.query.before - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getNotifications = <ThrowOnError extends boolean = true>(
  options?: Options<GetNotificationsData, ThrowOnError>,
): RequestResult<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetNotificationsQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetNotificationsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/notifications',
    ...options,
  });

/**
 * Mark notifications as read
 *
 * Marks specific notifications read by id, everything sharing one context, or all unread notifications when the body is empty. Idempotent.
 *
 * **POST /notifications/read** ·· [markNotificationsRead](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/POST/notifications/read) ·· _notifications_
 *
 * @param {markNotificationsReadData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @param {string=} options.body.contextId - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const markNotificationsRead = <ThrowOnError extends boolean = true>(
  options: Options<MarkNotificationsReadData, ThrowOnError>,
): RequestResult<MarkNotificationsReadResponses, MarkNotificationsReadErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<MarkNotificationsReadResponses, MarkNotificationsReadErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zMarkNotificationsReadBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zMarkNotificationsReadResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/notifications/read',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get notification preferences
 *
 * Email and digest preferences for the current user. In-app delivery is not opt-out.
 *
 * **GET /notifications/preferences** ·· [getNotificationPreferences](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/GET/notifications/preferences) ·· _notifications_
 *
 * @param {getNotificationPreferencesData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getNotificationPreferences = <ThrowOnError extends boolean = true>(
  options?: Options<GetNotificationPreferencesData, ThrowOnError>,
): RequestResult<GetNotificationPreferencesResponses, GetNotificationPreferencesErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<
    GetNotificationPreferencesResponses,
    GetNotificationPreferencesErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetNotificationPreferencesResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/notifications/preferences',
    ...options,
  });

/**
 * Update notification preferences
 *
 * Partial update; unspecified keys keep their stored value.
 *
 * **PATCH /notifications/preferences** ·· [updateNotificationPreferences](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/PATCH/notifications/preferences) ·· _notifications_
 *
 * @param {updateNotificationPreferencesData} options
 * @param {boolean=} options.body.mentionEmail - `boolean` (optional)
 * @param {boolean=} options.body.commentEmail - `boolean` (optional)
 * @param {enum=} options.body.digest - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateNotificationPreferences = <ThrowOnError extends boolean = true>(
  options: Options<UpdateNotificationPreferencesData, ThrowOnError>,
): RequestResult<UpdateNotificationPreferencesResponses, UpdateNotificationPreferencesErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).patch<
    UpdateNotificationPreferencesResponses,
    UpdateNotificationPreferencesErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateNotificationPreferencesBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateNotificationPreferencesResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/notifications/preferences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Unsubscribe from a notification category
 *
 * Turns off one email category from a link in an email. The token identifies the user and the category, so unsubscribing from the digest leaves other email untouched. No auth.
 *
 * **GET /notifications/unsubscribe** ·· [unsubscribeNotifications](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/GET/notifications/unsubscribe) ·· _notifications_
 *
 * @param {unsubscribeNotificationsData} options
 * @param {string} options.query.user - `string`
 * @param {enum} options.query.category - `enum`
 * @param {string} options.query.token - `string`
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const unsubscribeNotifications = <ThrowOnError extends boolean = true>(
  options: Options<UnsubscribeNotificationsData, ThrowOnError>,
): RequestResult<unknown, UnsubscribeNotificationsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, UnsubscribeNotificationsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zUnsubscribeNotificationsQuery,
        })
        .parseAsync(data),
    responseStyle: 'data',
    url: '/notifications/unsubscribe',
    ...options,
  });

/**
 * Get the Web Push application server key
 *
 * Returns the VAPID public key `PushManager.subscribe()` needs, or null when this deployment has no push keys configured; the client then offers no push toggle.
 *
 * **GET /push/vapid** ·· [getPushVapid](https://www.cellajs.com/docs/operations?operationTag=push#tag/push/GET/push/vapid) ·· _push_
 *
 * @param {getPushVapidData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getPushVapid = <ThrowOnError extends boolean = true>(
  options?: Options<GetPushVapidData, ThrowOnError>,
): RequestResult<GetPushVapidResponses, GetPushVapidErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetPushVapidResponses, GetPushVapidErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetPushVapidResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/push/vapid',
    ...options,
  });

/**
 * Remove a Web Push subscription
 *
 * Deletes the given endpoint for the current user; an endpoint owned by someone else is a no-op.
 *
 * **DELETE /push/subscriptions** ·· [deletePushSubscription](https://www.cellajs.com/docs/operations?operationTag=push#tag/push/DELETE/push/subscriptions) ·· _push_
 *
 * @param {deletePushSubscriptionData} options
 * @param {string} options.query.endpoint - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const deletePushSubscription = <ThrowOnError extends boolean = true>(
  options: Options<DeletePushSubscriptionData, ThrowOnError>,
): RequestResult<DeletePushSubscriptionResponses, DeletePushSubscriptionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<
    DeletePushSubscriptionResponses,
    DeletePushSubscriptionErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zDeletePushSubscriptionQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeletePushSubscriptionResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/push/subscriptions',
    ...options,
  });

/**
 * Register a Web Push subscription
 *
 * Stores the browser push subscription for the current user. Upserts by endpoint, so re-subscribing after key rotation reclaims the row.
 *
 * **POST /push/subscriptions** ·· [createPushSubscription](https://www.cellajs.com/docs/operations?operationTag=push#tag/push/POST/push/subscriptions) ·· _push_
 *
 * @param {createPushSubscriptionData} options
 * @param {string=} options.body.endpoint - `string` (optional)
 * @param {number | null=} options.body.expirationTime - `number | null` (optional)
 * @param {object} options.body.keys - `object`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const createPushSubscription = <ThrowOnError extends boolean = true>(
  options: Options<CreatePushSubscriptionData, ThrowOnError>,
): RequestResult<CreatePushSubscriptionResponses, CreatePushSubscriptionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreatePushSubscriptionResponses, CreatePushSubscriptionErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreatePushSubscriptionBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreatePushSubscriptionResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/push/subscriptions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete requests
 *
 * Deletes one or more requests from the system by their IDs.
 *
 * **DELETE /requests** ·· [deleteRequests](https://www.cellajs.com/docs/operations?operationTag=requests#tag/requests/DELETE/requests) ·· [deleteRequests](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/requests) ·· _requests_cella_
 *
 * @param {deleteRequestsData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const deleteRequests = <ThrowOnError extends boolean = true>(
  options: Options<DeleteRequestsData, ThrowOnError>,
): RequestResult<DeleteRequestsResponses, DeleteRequestsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteRequestsResponses, DeleteRequestsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteRequestsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteRequestsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of requests
 *
 * Returns a list of submitted requests across all types: contact form, newsletter, and waitlist.
 *
 * **GET /requests** ·· [getRequests](https://www.cellajs.com/docs/operations?operationTag=requests#tag/requests/GET/requests) ·· [getRequests](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/requests) ·· _requests_cella_
 *
 * @param {getRequestsData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @param {string=} options.query.seqcursor - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getRequests = <ThrowOnError extends boolean = true>(
  options?: Options<GetRequestsData, ThrowOnError>,
): RequestResult<GetRequestsResponses, GetRequestsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetRequestsResponses, GetRequestsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetRequestsQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetRequestsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/requests',
    ...options,
  });

/**
 * Create request
 *
 * Submits a request: a contact form message, a newsletter signup or a waitlist entry. Every submission gets the same answer: an address that has an account gets an email pointing to sign-in, and a repeat of a waitlist or newsletter signup is dropped.
 *
 * **POST /requests** ·· [createRequest](https://www.cellajs.com/docs/operations?operationTag=requests#tag/requests/POST/requests) ·· [createRequest](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/requests) ·· _requests_cella_
 *
 * @param {createRequestData} options
 * @param {string=} options.body.email - `string` (optional)
 * @param {enum=} options.body.type - `enum` (optional)
 * @param {string | null=} options.body.message - `string | null` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const createRequest = <ThrowOnError extends boolean = true>(
  options: Options<CreateRequestData, ThrowOnError>,
): RequestResult<CreateRequestResponses, CreateRequestErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateRequestResponses, CreateRequestErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateRequestBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreateRequestResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get unseen counts
 *
 * Returns the number of unseen product entities per parent channel entity (e.g., project) and entity type for the current user. Computed within the rolling seen window so entities older than seen_by retention do not participate.
 *
 * **GET /unseen/counts** ·· [getUnseenCounts](https://www.cellajs.com/docs/operations?operationTag=seen#tag/seen/GET/unseen/counts) ·· [getUnseenCounts](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/unseen/counts) ·· _seen_cella_
 *
 * @param {getUnseenCountsData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getUnseenCounts = <ThrowOnError extends boolean = true>(
  options?: Options<GetUnseenCountsData, ThrowOnError>,
): RequestResult<GetUnseenCountsResponses, GetUnseenCountsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetUnseenCountsResponses, GetUnseenCountsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetUnseenCountsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/unseen/counts',
    ...options,
  });

/**
 * Invite to system
 *
 * Invites one or more users to the system via email. Can be used to onboard system level users or admins.
 *
 * **POST /system/invite** ·· [systemInvite](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/POST/system/invite) ·· [systemInvite](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/system/invite) ·· _system_cella_
 *
 * @param {systemInviteData} options
 * @param {any[]=} options.body.emails - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const systemInvite = <ThrowOnError extends boolean = true>(
  options: Options<SystemInviteData, ThrowOnError>,
): RequestResult<SystemInviteResponses, SystemInviteErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SystemInviteResponses, SystemInviteErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSystemInviteBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSystemInviteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/system/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete users
 *
 * Deletes one or more users from the system based on a list of IDs. This also removes the user's memberships (cascade) and sets references to the user to null where applicable.
 *
 * **DELETE /system** ·· [deleteUsers](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/DELETE/system) ·· [deleteUsers](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/system) ·· _system_cella_
 *
 * @param {deleteUsersData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const deleteUsers = <ThrowOnError extends boolean = true>(
  options: Options<DeleteUsersData, ThrowOnError>,
): RequestResult<DeleteUsersResponses, DeleteUsersErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteUsersResponses, DeleteUsersErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteUsersBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteUsersResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/system',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update user
 *
 * Updates a user identified by ID.
 *
 * **PUT /system/{id}** ·· [updateUser](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/PUT/system/{id}) ·· [updateUser](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/system/{id}) ·· _system_cella_
 *
 * @param {updateUserData} options
 * @param {string} options.path.id - `string`
 * @param {string | null=} options.body.bannerUrl - `string | null` (optional)
 * @param {string | null=} options.body.description - `string | null` (optional)
 * @param {string | null=} options.body.firstName - `string | null` (optional)
 * @param {string | null=} options.body.lastName - `string | null` (optional)
 * @param {enum=} options.body.language - `enum` (optional)
 * @param {boolean=} options.body.newsletter - `boolean` (optional)
 * @param {string | null=} options.body.thumbnailUrl - `string | null` (optional)
 * @param {string=} options.body.slug - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateUser = <ThrowOnError extends boolean = true>(
  options: Options<UpdateUserData, ThrowOnError>,
): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateUserBody,
          path: zUpdateUserPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateUserResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/system/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Newsletter to members
 *
 * Sends a newsletter to members of one or more specified organizations.
 *
 * **POST /system/newsletter** ·· [sendNewsletter](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/POST/system/newsletter) ·· [sendNewsletter](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/system/newsletter) ·· _system_cella_
 *
 * @param {sendNewsletterData} options
 * @param {any=} options.query.toself - `any` (optional)
 * @param {any[]=} options.body.organizationIds - `any[]` (optional)
 * @param {any[]=} options.body.roles - `any[]` (optional)
 * @param {string=} options.body.subject - `string` (optional)
 * @param {string=} options.body.content - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const sendNewsletter = <ThrowOnError extends boolean = true>(
  options: Options<SendNewsletterData, ThrowOnError>,
): RequestResult<SendNewsletterResponses, SendNewsletterErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SendNewsletterResponses, SendNewsletterErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSendNewsletterBody,
          path: z.never().optional(),
          query: zSendNewsletterQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSendNewsletterResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/system/newsletter',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of tenants
 *
 * Returns a paginated list of tenants. System admin access required.
 *
 * **GET /tenants** ·· [getTenants](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/GET/tenants) ·· [getTenants](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/tenants) ·· _tenants_cella_
 *
 * @param {getTenantsData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @param {string=} options.query.seqcursor - `string` (optional)
 * @param {enum=} options.query.status - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getTenants = <ThrowOnError extends boolean = true>(
  options?: Options<GetTenantsData, ThrowOnError>,
): RequestResult<GetTenantsResponses, GetTenantsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetTenantsResponses, GetTenantsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetTenantsQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetTenantsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants',
    ...options,
  });

/**
 * Create a tenant for yourself
 *
 * Creates a new tenant (workspace) for the authenticated user. A user may own multiple tenants; an org-less tenant from a prior failed attempt is reused instead of creating a duplicate.
 *
 * **POST /tenants/self** ·· [selfCreateTenant](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/POST/tenants/self) ·· [selfCreateTenant](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/tenants/self) ·· _tenants_cella_
 *
 * @param {selfCreateTenantData} options
 * @param {string=} options.body.name - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const selfCreateTenant = <ThrowOnError extends boolean = true>(
  options: Options<SelfCreateTenantData, ThrowOnError>,
): RequestResult<SelfCreateTenantResponses, SelfCreateTenantErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SelfCreateTenantResponses, SelfCreateTenantErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSelfCreateTenantBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zSelfCreateTenantResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants/self',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a tenant
 *
 * Updates a tenant by ID. System admin access required.
 *
 * **PUT /tenants/{tenantId}** ·· [updateTenant](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/PUT/tenants/{tenantId}) ·· [updateTenant](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/tenants/{tenantId}) ·· _tenants_cella_
 *
 * @param {updateTenantData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {enum=} options.body.status - `enum` (optional)
 * @param {string | null=} options.body.subscriptionId - `string | null` (optional)
 * @param {enum=} options.body.subscriptionStatus - `enum` (optional)
 * @param {string | null=} options.body.subscriptionPlan - `string | null` (optional)
 * @param {any[]=} options.body.authStrategies - `any[]` (optional)
 * @param {object=} options.body.restrictions - `object` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateTenant = <ThrowOnError extends boolean = true>(
  options: Options<UpdateTenantData, ThrowOnError>,
): RequestResult<UpdateTenantResponses, UpdateTenantErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateTenantResponses, UpdateTenantErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateTenantBody,
          path: zUpdateTenantPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateTenantResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/tenants/{tenantId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of users
 *
 * Returns a list of users. Only system admins receive the system `role`, and only they may filter or sort by it.
 *
 * **GET /users/users** ·· [getUsers](https://www.cellajs.com/docs/operations?operationTag=users#tag/users/GET/users/users) ·· [getUsers](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/users/users) ·· _users_cella_
 *
 * @param {getUsersData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @param {string=} options.query.seqcursor - `string` (optional)
 * @param {enum=} options.query.role - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getUsers = <ThrowOnError extends boolean = true>(
  options?: Options<GetUsersData, ThrowOnError>,
): RequestResult<GetUsersResponses, GetUsersErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetUsersQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetUsersResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/users/users',
    ...options,
  });

/**
 * Get user
 *
 * Retrieves a user by ID. The requesting user must share at least one organization membership. Pass ?slug=true to resolve by slug instead.
 *
 * **GET /users/users/{relatableUserId}** ·· [getUser](https://www.cellajs.com/docs/operations?operationTag=users#tag/users/GET/users/users/{relatableUserId}) ·· [getUser](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/users/users/{relatableUserId}) ·· _users_cella_
 *
 * @param {getUserData} options
 * @param {string} options.path.relatableuserid - `string`
 * @param {any=} options.query.slug - `any` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getUser = <ThrowOnError extends boolean = true>(
  options: Options<GetUserData, ThrowOnError>,
): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetUserPath,
          query: zGetUserQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetUserResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/users/users/{relatableUserId}',
    ...options,
  });

/**
 * Protected resource metadata (API)
 *
 * RFC 9728 metadata of this tenant as an API resource: its resource identifier, the authorization server that issues tokens for it, and the scopes it understands.
 *
 * **GET /{tenantId}/.well-known/oauth-protected-resource** ·· [getApiProtectedResourceMetadata](https://www.cellajs.com/docs/operations?operationTag=oauth-server#tag/oauth-server/GET/{tenantId}/.well-known/oauth-protected-resource) ·· [getApiProtectedResourceMetadata](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/.well-known/oauth-protected-resource) ·· _oauth-server_cella_
 *
 * @param {getApiProtectedResourceMetadataData} options
 * @param {string} options.path.tenantid - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getApiProtectedResourceMetadata = <ThrowOnError extends boolean = true>(
  options: Options<GetApiProtectedResourceMetadataData, ThrowOnError>,
): RequestResult<
  GetApiProtectedResourceMetadataResponses,
  GetApiProtectedResourceMetadataErrors,
  ThrowOnError,
  'data'
> =>
  (options.client ?? client).get<
    GetApiProtectedResourceMetadataResponses,
    GetApiProtectedResourceMetadataErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetApiProtectedResourceMetadataPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetApiProtectedResourceMetadataResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/.well-known/oauth-protected-resource',
    ...options,
  });

/**
 * Delete organizations
 *
 * Deletes one or more organizations by ID within a tenant.
 *
 * **DELETE /{tenantId}/organizations** ·· [deleteOrganizations](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/DELETE/{tenantId}/organizations) ·· [deleteOrganizations](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/{tenantId}/organizations) ·· [deleteOrganizations](https://www.cellajs.com/docs/operations?operationTag=channel#tag/channel/DELETE/{tenantId}/organizations) ·· _organizations_cella_channel_
 *
 * @param {deleteOrganizationsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const deleteOrganizations = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrganizationsData, ThrowOnError>,
): RequestResult<DeleteOrganizationsResponses, DeleteOrganizationsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteOrganizationsResponses, DeleteOrganizationsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteOrganizationsBody,
          path: zDeleteOrganizationsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteOrganizationsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create organizations
 *
 * Creates one or more new organizations within a tenant.
 *
 * **POST /{tenantId}/organizations** ·· [createOrganizations](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/POST/{tenantId}/organizations) ·· [createOrganizations](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/organizations) ·· [createOrganizations](https://www.cellajs.com/docs/operations?operationTag=channel#tag/channel/POST/{tenantId}/organizations) ·· _organizations_cella_channel_
 *
 * @param {createOrganizationsData} options
 * @param {string} options.path.tenantid - `string`
 * @returns Possible status codes: 201, 400, 401, 403, 404, 409, 429
 */
export const createOrganizations = <ThrowOnError extends boolean = true>(
  options: Options<CreateOrganizationsData, ThrowOnError>,
): RequestResult<CreateOrganizationsResponses, CreateOrganizationsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateOrganizationsResponses, CreateOrganizationsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateOrganizationsBody,
          path: zCreateOrganizationsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreateOrganizationsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of organizations
 *
 * Returns a list of organizations.
 *
 * **GET /organizations** ·· [getOrganizations](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/GET/organizations) ·· [getOrganizations](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/organizations) ·· [getOrganizations](https://www.cellajs.com/docs/operations?operationTag=channel#tag/channel/GET/organizations) ·· _organizations_cella_channel_
 *
 * @param {getOrganizationsData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @param {string=} options.query.seqcursor - `string` (optional)
 * @param {string=} options.query.relatableuserid - `string` (optional)
 * @param {enum=} options.query.role - `enum` (optional)
 * @param {enum=} options.query.excludearchived - `enum` (optional)
 * @param {string=} options.query.include - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getOrganizations = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrganizationsData, ThrowOnError>,
): RequestResult<GetOrganizationsResponses, GetOrganizationsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetOrganizationsResponses, GetOrganizationsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetOrganizationsQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetOrganizationsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/organizations',
    ...options,
  });

/**
 * Get organization
 *
 * Retrieves an organization by ID within a tenant. Pass ?slug=true to resolve by slug instead.
 *
 * **GET /{tenantId}/organizations/{id}** ·· [getOrganization](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/GET/{tenantId}/organizations/{id}) ·· [getOrganization](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/organizations/{id}) ·· [getOrganization](https://www.cellajs.com/docs/operations?operationTag=channel#tag/channel/GET/{tenantId}/organizations/{id}) ·· _organizations_cella_channel_
 *
 * @param {getOrganizationData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.id - `string`
 * @param {any=} options.query.slug - `any` (optional)
 * @param {string=} options.query.include - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getOrganization = <ThrowOnError extends boolean = true>(
  options: Options<GetOrganizationData, ThrowOnError>,
): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetOrganizationPath,
          query: zGetOrganizationQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetOrganizationResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/organizations/{id}',
    ...options,
  });

/**
 * Update organization
 *
 * Updates an organization within a tenant.
 *
 * **PUT /{tenantId}/organizations/{id}** ·· [updateOrganization](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/PUT/{tenantId}/organizations/{id}) ·· [updateOrganization](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/{tenantId}/organizations/{id}) ·· [updateOrganization](https://www.cellajs.com/docs/operations?operationTag=channel#tag/channel/PUT/{tenantId}/organizations/{id}) ·· _organizations_cella_channel_
 *
 * @param {updateOrganizationData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.id - `string`
 * @param {string=} options.body.slug - `string` (optional)
 * @param {string=} options.body.name - `string` (optional)
 * @param {string | null=} options.body.shortName - `string | null` (optional)
 * @param {string | null=} options.body.country - `string | null` (optional)
 * @param {string | null=} options.body.timezone - `string | null` (optional)
 * @param {enum=} options.body.defaultLanguage - `enum` (optional)
 * @param {any[]=} options.body.languages - `any[]` (optional)
 * @param {string | null=} options.body.notificationEmail - `string | null` (optional)
 * @param {string | null=} options.body.color - `string | null` (optional)
 * @param {string | null=} options.body.thumbnailUrl - `string | null` (optional)
 * @param {string | null=} options.body.logoUrl - `string | null` (optional)
 * @param {string | null=} options.body.bannerUrl - `string | null` (optional)
 * @param {string | null=} options.body.websiteUrl - `string | null` (optional)
 * @param {string | null=} options.body.welcomeText - `string | null` (optional)
 * @param {boolean=} options.body.chatSupport - `boolean` (optional)
 * @param {object=} options.body.organizationFlags - `object` (optional)
 * @param {object=} options.body.setupConfig - `object` (optional)
 * @param {object=} options.body.toolsConfig - `object` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateOrganization = <ThrowOnError extends boolean = true>(
  options: Options<UpdateOrganizationData, ThrowOnError>,
): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateOrganizationBody,
          path: zUpdateOrganizationPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateOrganizationResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/organizations/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete attachments
 *
 * Deletes one or more attachment records by ID. This does not delete the underlying file in storage.
 *
 * **DELETE /{tenantId}/{organizationId}/attachments** ·· [deleteAttachments](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/DELETE/{tenantId}/{organizationId}/attachments) ·· [deleteAttachments](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/{tenantId}/{organizationId}/attachments) ·· [deleteAttachments](https://www.cellajs.com/docs/operations?operationTag=product#tag/product/DELETE/{tenantId}/{organizationId}/attachments) ·· _attachments_cella_product_
 *
 * @param {deleteAttachmentsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @param {object} options.body.stx - `object`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const deleteAttachments = <ThrowOnError extends boolean = true>(
  options: Options<DeleteAttachmentsData, ThrowOnError>,
): RequestResult<DeleteAttachmentsResponses, DeleteAttachmentsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteAttachmentsResponses, DeleteAttachmentsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteAttachmentsBody,
          path: zDeleteAttachmentsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteAttachmentsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/{organizationId}/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get attachments
 *
 * Returns a paginated list of attachments for the organization.
 *
 * **GET /{tenantId}/{organizationId}/attachments** ·· [getAttachments](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/GET/{tenantId}/{organizationId}/attachments) ·· [getAttachments](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/attachments) ·· [getAttachments](https://www.cellajs.com/docs/operations?operationTag=product#tag/product/GET/{tenantId}/{organizationId}/attachments) ·· _attachments_cella_product_
 *
 * @param {getAttachmentsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @param {string=} options.query.seqcursor - `string` (optional)
 * @param {string=} options.query.channelid - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getAttachments = <ThrowOnError extends boolean = true>(
  options: Options<GetAttachmentsData, ThrowOnError>,
): RequestResult<GetAttachmentsResponses, GetAttachmentsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetAttachmentsResponses, GetAttachmentsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAttachmentsPath,
          query: zGetAttachmentsQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetAttachmentsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/{organizationId}/attachments',
    ...options,
  });

/**
 * Create attachments
 *
 * Registers one or more new attachments after client side upload. Includes metadata like name, type, and linked entity.
 *
 * **POST /{tenantId}/{organizationId}/attachments** ·· [createAttachments](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/POST/{tenantId}/{organizationId}/attachments) ·· [createAttachments](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/attachments) ·· [createAttachments](https://www.cellajs.com/docs/operations?operationTag=product#tag/product/POST/{tenantId}/{organizationId}/attachments) ·· _attachments_cella_product_
 *
 * @param {createAttachmentsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @returns Possible status codes: 200, 201, 400, 401, 403, 404, 409, 429
 */
export const createAttachments = <ThrowOnError extends boolean = true>(
  options: Options<CreateAttachmentsData, ThrowOnError>,
): RequestResult<CreateAttachmentsResponses, CreateAttachmentsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateAttachmentsResponses, CreateAttachmentsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateAttachmentsBody,
          path: zCreateAttachmentsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreateAttachmentsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/{organizationId}/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get presigned URLs
 *
 * Signs download URLs for up to 50 private attachment files in one call, referenced by id + variant. Missing and denied ids come back in a uniform rejectedIds list (no 403/404 split), and the call succeeds even when every item is rejected. Public files should use the public CDN URL directly. Requires organization context.
 *
 * **POST /{tenantId}/{organizationId}/attachments/presigned-urls** ·· [getPresignedUrls](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/POST/{tenantId}/{organizationId}/attachments/presigned-urls) ·· [getPresignedUrls](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/attachments/presigned-urls) ·· [getPresignedUrls](https://www.cellajs.com/docs/operations?operationTag=product#tag/product/POST/{tenantId}/{organizationId}/attachments/presigned-urls) ·· _attachments_cella_product_
 *
 * @param {getPresignedUrlsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {any[]=} options.body.items - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getPresignedUrls = <ThrowOnError extends boolean = true>(
  options: Options<GetPresignedUrlsData, ThrowOnError>,
): RequestResult<GetPresignedUrlsResponses, GetPresignedUrlsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<GetPresignedUrlsResponses, GetPresignedUrlsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGetPresignedUrlsBody,
          path: zGetPresignedUrlsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetPresignedUrlsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/{organizationId}/attachments/presigned-urls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get attachment
 *
 * Returns a single attachment by ID. Served from the CDC-invalidated entity detail cache.
 *
 * **GET /{tenantId}/{organizationId}/attachments/{id}** ·· [getAttachment](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/GET/{tenantId}/{organizationId}/attachments/{id}) ·· [getAttachment](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/attachments/{id}) ·· [getAttachment](https://www.cellajs.com/docs/operations?operationTag=product#tag/product/GET/{tenantId}/{organizationId}/attachments/{id}) ·· _attachments_cella_product_
 *
 * @param {getAttachmentData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getAttachment = <ThrowOnError extends boolean = true>(
  options: Options<GetAttachmentData, ThrowOnError>,
): RequestResult<GetAttachmentResponses, GetAttachmentErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetAttachmentResponses, GetAttachmentErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAttachmentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetAttachmentResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/{organizationId}/attachments/{id}',
    ...options,
  });

/**
 * Update attachment
 *
 * Updates metadata of an attachment, such as its name or associated entity.
 *
 * **PUT /{tenantId}/{organizationId}/attachments/{id}** ·· [updateAttachment](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/PUT/{tenantId}/{organizationId}/attachments/{id}) ·· [updateAttachment](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/{tenantId}/{organizationId}/attachments/{id}) ·· [updateAttachment](https://www.cellajs.com/docs/operations?operationTag=product#tag/product/PUT/{tenantId}/{organizationId}/attachments/{id}) ·· _attachments_cella_product_
 *
 * @param {updateAttachmentData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @param {any=} options.query.fullresponse - `any` (optional)
 * @param {object=} options.body.ops - `object` (optional)
 * @param {any=} options.body.stx - `any` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateAttachment = <ThrowOnError extends boolean = true>(
  options: Options<UpdateAttachmentData, ThrowOnError>,
): RequestResult<UpdateAttachmentResponses, UpdateAttachmentErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateAttachmentResponses, UpdateAttachmentErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateAttachmentBody,
          path: zUpdateAttachmentPath,
          query: zUpdateAttachmentQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateAttachmentResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
      {
        key: 'apiKey',
        scheme: 'bearer',
        type: 'http',
      },
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/{organizationId}/attachments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Protected resource metadata
 *
 * RFC 9728 metadata of this organization MCP server: its resource identifier, the authorization server that issues tokens for it, and the scopes it understands.
 *
 * **GET /{tenantId}/{organizationId}/mcp/.well-known/oauth-protected-resource** ·· [getMcpProtectedResourceMetadata](https://www.cellajs.com/docs/operations?operationTag=mcp#tag/mcp/GET/{tenantId}/{organizationId}/mcp/.well-known/oauth-protected-resource) ·· [getMcpProtectedResourceMetadata](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/mcp/.well-known/oauth-protected-resource) ·· _mcp_cella_
 *
 * @param {getMcpProtectedResourceMetadataData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getMcpProtectedResourceMetadata = <ThrowOnError extends boolean = true>(
  options: Options<GetMcpProtectedResourceMetadataData, ThrowOnError>,
): RequestResult<
  GetMcpProtectedResourceMetadataResponses,
  GetMcpProtectedResourceMetadataErrors,
  ThrowOnError,
  'data'
> =>
  (options.client ?? client).get<
    GetMcpProtectedResourceMetadataResponses,
    GetMcpProtectedResourceMetadataErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetMcpProtectedResourceMetadataPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetMcpProtectedResourceMetadataResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/mcp/.well-known/oauth-protected-resource',
    ...options,
  });

/**
 * MCP endpoint
 *
 * Model Context Protocol (JSON-RPC 2.0 over Streamable HTTP) endpoint. Requires an access token from the authorization server; exposes the MCP tools that modules registered (initialize, tools/list, tools/call). A call outside the token scopes answers 403 with a WWW-Authenticate challenge naming the scope to step up to.
 *
 * **POST /{tenantId}/{organizationId}/mcp** ·· [handleMcp](https://www.cellajs.com/docs/operations?operationTag=mcp#tag/mcp/POST/{tenantId}/{organizationId}/mcp) ·· [handleMcp](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/mcp) ·· _mcp_cella_
 *
 * @param {handleMcpData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const handleMcp = <ThrowOnError extends boolean = true>(
  options: Options<HandleMcpData, ThrowOnError>,
): RequestResult<HandleMcpResponses, HandleMcpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<HandleMcpResponses, HandleMcpErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zHandleMcpBody,
          path: zHandleMcpPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        key: 'oauth2',
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/{tenantId}/{organizationId}/mcp',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete memberships
 *
 * Deletes one or more memberships by ID. This removes the membership but does not delete the associated user(s).
 *
 * **DELETE /{tenantId}/{organizationId}/memberships** ·· [deleteMemberships](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/DELETE/{tenantId}/{organizationId}/memberships) ·· [deleteMemberships](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/{tenantId}/{organizationId}/memberships) ·· _memberships_cella_
 *
 * @param {deleteMembershipsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.query.entityid - `string`
 * @param {enum} options.query.entitytype - `enum`
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const deleteMemberships = <ThrowOnError extends boolean = true>(
  options: Options<DeleteMembershipsData, ThrowOnError>,
): RequestResult<DeleteMembershipsResponses, DeleteMembershipsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteMembershipsResponses, DeleteMembershipsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteMembershipsBody,
          path: zDeleteMembershipsPath,
          query: zDeleteMembershipsQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zDeleteMembershipsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/memberships',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create memberships
 *
 * Creates one or more memberships, inviting users (existing or new) to a channel entity such as an organization. A created membership carries muted, archived and display order only when it is the caller's own.
 *
 * **POST /{tenantId}/{organizationId}/memberships** ·· [membershipInvite](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/POST/{tenantId}/{organizationId}/memberships) ·· [membershipInvite](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/memberships) ·· _memberships_cella_
 *
 * @param {membershipInviteData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.query.entityid - `string`
 * @param {enum} options.query.entitytype - `enum`
 * @param {any[]=} options.body.emails - `any[]` (optional)
 * @param {enum=} options.body.role - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const membershipInvite = <ThrowOnError extends boolean = true>(
  options: Options<MembershipInviteData, ThrowOnError>,
): RequestResult<MembershipInviteResponses, MembershipInviteErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<MembershipInviteResponses, MembershipInviteErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zMembershipInviteBody,
          path: zMembershipInvitePath,
          query: zMembershipInviteQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zMembershipInviteResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/memberships',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update membership
 *
 * Updates a membership: its role, or the muted, archived or display order status. Send at least one field. Muted, archived and display order are set by the member only, and the response carries them only on the caller's own membership. A role change, and any change to another member's membership, requires update permission on the channel.
 *
 * **PUT /{tenantId}/{organizationId}/memberships/{id}** ·· [updateMembership](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/PUT/{tenantId}/{organizationId}/memberships/{id}) ·· [updateMembership](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/{tenantId}/{organizationId}/memberships/{id}) ·· _memberships_cella_
 *
 * @param {updateMembershipData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @param {enum=} options.body.role - `enum` (optional)
 * @param {boolean=} options.body.archived - `boolean` (optional)
 * @param {boolean=} options.body.muted - `boolean` (optional)
 * @param {number=} options.body.displayOrder - `number` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateMembership = <ThrowOnError extends boolean = true>(
  options: Options<UpdateMembershipData, ThrowOnError>,
): RequestResult<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateMembershipBody,
          path: zUpdateMembershipPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateMembershipResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/memberships/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Respond to membership invitation
 *
 * Accepting activates the associated membership. Rejecting simply removes the invitation token.
 *
 * **POST /{tenantId}/{organizationId}/memberships/{id}/{acceptOrReject}** ·· [handleMembershipInvitation](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/POST/{tenantId}/{organizationId}/memberships/{id}/{acceptOrReject}) ·· [handleMembershipInvitation](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/memberships/{id}/{acceptOrReject}) ·· _memberships_cella_
 *
 * @param {handleMembershipInvitationData} options
 * @param {string} options.path.id - `string`
 * @param {enum} options.path.acceptorreject - `enum`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const handleMembershipInvitation = <ThrowOnError extends boolean = true>(
  options: Options<HandleMembershipInvitationData, ThrowOnError>,
): RequestResult<HandleMembershipInvitationResponses, HandleMembershipInvitationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<
    HandleMembershipInvitationResponses,
    HandleMembershipInvitationErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHandleMembershipInvitationPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zHandleMembershipInvitationResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/memberships/{id}/{acceptOrReject}',
    ...options,
  });

/**
 * Get list of members
 *
 * Retrieves members (users) of a channel entity by ID, including their associated membership data.
 *
 * **GET /{tenantId}/{organizationId}/memberships/members** ·· [getMembers](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/GET/{tenantId}/{organizationId}/memberships/members) ·· [getMembers](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/memberships/members) ·· _memberships_cella_
 *
 * @param {getMembersData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @param {string=} options.query.seqcursor - `string` (optional)
 * @param {string} options.query.entityid - `string`
 * @param {enum} options.query.entitytype - `enum`
 * @param {enum=} options.query.role - `enum` (optional)
 * @param {string=} options.query.include - `string` (optional)
 * @param {string=} options.query.userids - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getMembers = <ThrowOnError extends boolean = true>(
  options: Options<GetMembersData, ThrowOnError>,
): RequestResult<GetMembersResponses, GetMembersErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetMembersResponses, GetMembersErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetMembersPath,
          query: zGetMembersQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetMembersResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/memberships/members',
    ...options,
  });

/**
 * Get list of pending memberships
 *
 * Returns the pending invitations of a channel entity, identified by ID: the address each went to, its role and its inviter. A row looks the same whether an account holds the address or not.
 *
 * **GET /{tenantId}/{organizationId}/memberships/pending** ·· [getPendingMemberships](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/GET/{tenantId}/{organizationId}/memberships/pending) ·· [getPendingMemberships](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/memberships/pending) ·· _memberships_cella_
 *
 * @param {getPendingMembershipsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @param {string=} options.query.seqcursor - `string` (optional)
 * @param {string} options.query.entityid - `string`
 * @param {enum} options.query.entitytype - `enum`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getPendingMemberships = <ThrowOnError extends boolean = true>(
  options: Options<GetPendingMembershipsData, ThrowOnError>,
): RequestResult<GetPendingMembershipsResponses, GetPendingMembershipsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetPendingMembershipsResponses, GetPendingMembershipsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetPendingMembershipsPath,
          query: zGetPendingMembershipsQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetPendingMembershipsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/memberships/pending',
    ...options,
  });

/**
 * Resend pending invitation
 *
 * Re-sends the invitation email for a pending membership, named by its own id; an invitation holding a token gets a fresh one. Answers 204 alike for every pending invitation. Requires update permission on the invited channel; the public auth resend endpoint stays for invitees holding an expired token.
 *
 * **POST /{tenantId}/{organizationId}/memberships/pending/{id}/resend** ·· [resendPendingInvitation](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/POST/{tenantId}/{organizationId}/memberships/pending/{id}/resend) ·· [resendPendingInvitation](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/memberships/pending/{id}/resend) ·· _memberships_cella_
 *
 * @param {resendPendingInvitationData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 204, 400, 401, 403, 404, 409, 429
 */
export const resendPendingInvitation = <ThrowOnError extends boolean = true>(
  options: Options<ResendPendingInvitationData, ThrowOnError>,
): RequestResult<ResendPendingInvitationResponses, ResendPendingInvitationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<
    ResendPendingInvitationResponses,
    ResendPendingInvitationErrors,
    ThrowOnError,
    'data'
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zResendPendingInvitationPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zResendPendingInvitationResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/memberships/pending/{id}/resend',
    ...options,
  });

/**
 * Mark entities as seen
 *
 * Records that the current user has viewed one or more product entities. Deduplicates against existing records. Updates entity view counts for newly seen entities.
 *
 * **POST /{tenantId}/{organizationId}/seen** ·· [markSeen](https://www.cellajs.com/docs/operations?operationTag=seen#tag/seen/POST/{tenantId}/{organizationId}/seen) ·· [markSeen](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/seen) ·· _seen_cella_
 *
 * @param {markSeenData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {any[]=} options.body.entityIds - `any[]` (optional)
 * @param {enum=} options.body.entityType - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const markSeen = <ThrowOnError extends boolean = true>(
  options: Options<MarkSeenData, ThrowOnError>,
): RequestResult<MarkSeenResponses, MarkSeenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<MarkSeenResponses, MarkSeenErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zMarkSeenBody,
          path: zMarkSeenPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zMarkSeenResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/seen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get service accounts
 *
 * Lists the service accounts of this organization.
 *
 * **GET /{tenantId}/{organizationId}/service-accounts** ·· [getServiceAccounts](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/GET/{tenantId}/{organizationId}/service-accounts) ·· [getServiceAccounts](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/service-accounts) ·· _service-accounts_cella_
 *
 * @param {getServiceAccountsData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {string=} options.query.offset - `string` (optional)
 * @param {string=} options.query.limit - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getServiceAccounts = <ThrowOnError extends boolean = true>(
  options: Options<GetServiceAccountsData, ThrowOnError>,
): RequestResult<GetServiceAccountsResponses, GetServiceAccountsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetServiceAccountsResponses, GetServiceAccountsErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetServiceAccountsPath,
          query: zGetServiceAccountsQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetServiceAccountsResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/service-accounts',
    ...options,
  });

/**
 * Create service account
 *
 * Creates a machine actor bound to this organization at the given role (capped at your own), optionally issuing its first API key in the same call.
 *
 * **POST /{tenantId}/{organizationId}/service-accounts** ·· [createServiceAccount](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/POST/{tenantId}/{organizationId}/service-accounts) ·· [createServiceAccount](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/service-accounts) ·· _service-accounts_cella_
 *
 * @param {createServiceAccountData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {enum=} options.body.role - `enum` (optional)
 * @param {object} options.body.key - `object`
 * @returns Possible status codes: 201, 400, 401, 403, 404, 409, 429
 */
export const createServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<CreateServiceAccountData, ThrowOnError>,
): RequestResult<CreateServiceAccountResponses, CreateServiceAccountErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateServiceAccountResponses, CreateServiceAccountErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateServiceAccountBody,
          path: zCreateServiceAccountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreateServiceAccountResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/service-accounts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update service account
 *
 * Renames, disables or re-enables a service account. Accounts are never deleted.
 *
 * **PUT /{tenantId}/{organizationId}/service-accounts/{id}** ·· [updateServiceAccount](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/PUT/{tenantId}/{organizationId}/service-accounts/{id}) ·· [updateServiceAccount](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/PUT/{tenantId}/{organizationId}/service-accounts/{id}) ·· _service-accounts_cella_
 *
 * @param {updateServiceAccountData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {enum=} options.body.status - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const updateServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<UpdateServiceAccountData, ThrowOnError>,
): RequestResult<UpdateServiceAccountResponses, UpdateServiceAccountErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateServiceAccountResponses, UpdateServiceAccountErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateServiceAccountBody,
          path: zUpdateServiceAccountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zUpdateServiceAccountResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/service-accounts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get API keys
 *
 * Lists the API keys of a service account. Secrets are never returned here.
 *
 * **GET /{tenantId}/{organizationId}/service-accounts/{id}/keys** ·· [getApiKeys](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/GET/{tenantId}/{organizationId}/service-accounts/{id}/keys) ·· [getApiKeys](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/service-accounts/{id}/keys) ·· _service-accounts_cella_
 *
 * @param {getApiKeysData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getApiKeys = <ThrowOnError extends boolean = true>(
  options: Options<GetApiKeysData, ThrowOnError>,
): RequestResult<GetApiKeysResponses, GetApiKeysErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetApiKeysResponses, GetApiKeysErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetApiKeysPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetApiKeysResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/service-accounts/{id}/keys',
    ...options,
  });

/**
 * Create API key
 *
 * Issues an API key for a service account; the plaintext is returned once. With `rollFrom`, the previous key keeps working for the overlap window.
 *
 * **POST /{tenantId}/{organizationId}/service-accounts/{id}/keys** ·· [createApiKey](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/POST/{tenantId}/{organizationId}/service-accounts/{id}/keys) ·· [createApiKey](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/POST/{tenantId}/{organizationId}/service-accounts/{id}/keys) ·· _service-accounts_cella_
 *
 * @param {createApiKeyData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {any[] | null=} options.body.scopes - `any[] | null` (optional)
 * @param {string=} options.body.expiresAt - `string` (optional)
 * @param {string=} options.body.rollFrom - `string` (optional)
 * @param {integer=} options.body.rollOverlapDays - `integer` (optional)
 * @returns Possible status codes: 201, 400, 401, 403, 404, 409, 429
 */
export const createApiKey = <ThrowOnError extends boolean = true>(
  options: Options<CreateApiKeyData, ThrowOnError>,
): RequestResult<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateApiKeyBody,
          path: zCreateApiKeyPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zCreateApiKeyResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/service-accounts/{id}/keys',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Revoke API key
 *
 * Revokes an API key immediately. The row stays for the audit trail.
 *
 * **DELETE /{tenantId}/{organizationId}/service-accounts/{id}/keys/{keyId}** ·· [revokeApiKey](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/DELETE/{tenantId}/{organizationId}/service-accounts/{id}/keys/{keyId}) ·· [revokeApiKey](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/DELETE/{tenantId}/{organizationId}/service-accounts/{id}/keys/{keyId}) ·· _service-accounts_cella_
 *
 * @param {revokeApiKeyData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {string} options.path.id - `string`
 * @param {string} options.path.keyid - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const revokeApiKey = <ThrowOnError extends boolean = true>(
  options: Options<RevokeApiKeyData, ThrowOnError>,
): RequestResult<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zRevokeApiKeyPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) => await zRevokeApiKeyResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/service-accounts/{id}/keys/{keyId}',
    ...options,
  });

/**
 * Get Yjs token
 *
 * Returns an Ed25519-signed token for collaboratively editing one product entity the caller may update. It names the entity, its tenant and organization, and expires after five minutes; the Yjs relay worker verifies it with the public key alone, without a backend callback, and closes the socket when it expires.
 *
 * **GET /{tenantId}/{organizationId}/yjs/token** ·· [getYjsToken](https://www.cellajs.com/docs/operations?operationTag=yjs#tag/yjs/GET/{tenantId}/{organizationId}/yjs/token) ·· [getYjsToken](https://www.cellajs.com/docs/operations?operationTag=cella#tag/cella/GET/{tenantId}/{organizationId}/yjs/token) ·· _yjs_cella_
 *
 * @param {getYjsTokenData} options
 * @param {string} options.path.tenantid - `string`
 * @param {string} options.path.organizationid - `string`
 * @param {enum} options.query.entitytype - `enum`
 * @param {string} options.query.entityid - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const getYjsToken = <ThrowOnError extends boolean = true>(
  options: Options<GetYjsTokenData, ThrowOnError>,
): RequestResult<GetYjsTokenResponses, GetYjsTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetYjsTokenResponses, GetYjsTokenErrors, ThrowOnError, 'data'>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetYjsTokenPath,
          query: zGetYjsTokenQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) => await zGetYjsTokenResponse.parseAsync(data),
    responseStyle: 'data',
    security: [
      {
        in: 'cookie',
        name: 'cella-development-session-v3',
        type: 'apiKey',
      },
    ],
    url: '/{tenantId}/{organizationId}/yjs/token',
    ...options,
  });
